import { myOnlineStatusApi } from 'v5/api/online-status/online-status.api.connected';
import {
  apiClientCommunicationEvent,
  registerApiClientCommunicationEvent
} from 'v5/platform/api/apiClientCommunicationEvent.connected';
import { myToastService } from '../ToastService/ToastService.connected';
import { createOnlineStatusService } from './OnlineStatusService.impl';

registerApiClientCommunicationEvent();

export const myOnlineStatusService = createOnlineStatusService({
  api: myOnlineStatusApi,
  subscribeApiCommunication: callback =>
    apiClientCommunicationEvent.addListener(callback),
  services: {
    toastService: myToastService
  }
});
